import React from 'react';

const ConsentAgreement = (
    {
        consentIsChecked,
        changeConsentAgreements,
        textsMapping,
        consentCode,
        consentText
    }) => {
    return (
        <div className={`checkout-agreement form-field checkbox-single ${consentIsChecked ? '' : 'is-invalid'}`}>
            <input id={consentCode} type="checkbox" required onChange={() => changeConsentAgreements(consentCode)}
                   checked={consentIsChecked}/>
            <label htmlFor={consentCode}><span
                dangerouslySetInnerHTML={{__html: consentText}}/></label>
            <span className={`field-validation-error`}>{textsMapping.inputErrorMessageDefault}</span>
        </div>
    )
}

export default ConsentAgreement